module.exports = __webpack_public_path__ + "static/media/sz.4ffebab1.webp";